// extracted by mini-css-extract-plugin
export default {"dialogBox":"DialogBox_dialogBox__t6GAH"};